export * from './baProfilePicture.pipe';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/pipes/baProfilePicture/index.ts